import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { localNum } from "@faire/web--source/common/localization";
import { Star } from "@faire/web--source/slate/icons/foundation/Star";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import round from "lodash/round";
import React from "react";
import styled from "styled-components";
export var BrandRating = function(param) {
    var _param_brandReviewSummary = param.brandReviewSummary, average_rating = _param_brandReviewSummary.average_rating, number_of_reviews = _param_brandReviewSummary.number_of_reviews;
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Star, {
                fontSize: "14px",
                fill: Core.icon.default
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: 4
            }),
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: localNum(round(average_rating !== null && average_rating !== void 0 ? average_rating : 0, 1))
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: 4
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: "("
                    }),
                    /*#__PURE__*/ _jsx(UnderlineText, {
                        children: localNum(number_of_reviews)
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: ")"
                    })
                ]
            })
        ]
    });
};
var UnderlineText = styled(Typography).withConfig({
    componentId: "sc-16a84030-0"
})([
    "text-decoration:underline;"
]);
